import { render, staticRenderFns } from "./StatsProfile.vue?vue&type=template&id=0b5ea503"
import script from "./StatsProfile.vue?vue&type=script&lang=js"
export * from "./StatsProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports